import { Component, Input } from '@angular/core';

@Component({
  selector: 'gf-extra-field-renderer',
  template: require('./extra.field.renderer.component.html')
})
export class ExtraFieldRendererComponent {
  @Input() field: any;
  @Input() tracker: any;
  @Input() errors: any;
  @Input() acls: any;
  @Input() canUpdate: any;
  @Input() isNewTrackerItem: boolean;
  @Input() workflow: any;
  @Input() version: any;
}
